import { Input } from "antd";
import { CSSProperties, useEffect, useRef, useState } from "react";
import "./InlineEditor.css"

function useOutsideClickDetector(ref: any, callback: () => void) {
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback()
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [ref]);
}

export interface Props {
  value: string,
  onChange?: (newValue: string) => void,
  placeholder?: string,
  style?: CSSProperties
}

export default function InlineEditor({ value, onChange = () => { }, placeholder, style }: Props) {
  const editorRef = useRef(null)
  const valueRef = useRef('')
  valueRef.current = value

  const shouldBeInEditMode = (): boolean => !(valueRef.current?.trim())
  const updateEditMode = () => setInEditMode(shouldBeInEditMode())

  const [inEditMode, setInEditMode] = useState(shouldBeInEditMode())

  useOutsideClickDetector(editorRef, () => {
    updateEditMode()
  })

  // if focus editor when we enter edit mode - blur would work & no outside click handler

  return <>
    {inEditMode
      ? <span ref={editorRef}>
        <Input data-testid="editor"
          defaultValue={value}
          onBlur={() => updateEditMode()}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
        />
      </span>
      : <span data-testid="label" className="inlineEditorLabel" style={style} onClick={() => setInEditMode(true)}>
        {value}
      </span>
    }
  </>
}
